import store from 'store';
import { makeRequest } from 'utils/requestLogger';

// When the request succeeds
const successCourseDetails = (course) => {
  store.dispatch('setCourseDetail', course);
};
const successRTDetails = (rt) => {
  store.dispatch('updateRTDetails', rt);
};

const failed = (error) => {
  console.log('error', error);
};

const courseDetails = (courseId) => {
  makeRequest('get', `/api/courses/${courseId}`)
    .then((resp) => {
      successCourseDetails(resp.data);
    })
    .then(() => {
      store.dispatch('setRTLoading', false);
    })
    .catch((err) => {
      failed(err);
    });
};

export default (rtId) => {
  store.dispatch('setRTLoading', true);
  makeRequest('get', `/api/roundtables/${rtId}`)
    .then((response) => {
      successRTDetails(response.data);
      courseDetails(response.data.course_id);
    })
    .catch((error) => {
      failed(error);
    });
};



// WEBPACK FOOTER //
// ./src/app/services/courses/courseDetailsRtId.js